export default __webpack_public_path__ + "static/media/logo.06121f2e.svg";